<script setup lang="ts">
import { computed } from 'vue'

import type { SportStats, Stat } from '@collector/sportsapi-types'

import BinaryStatisticInput from './BinaryStatisticInput.vue'
import DecimalStatisticInput from './DecimalStatisticInput.vue'
import IntegerStatisticInput from './IntegerStatisticInput.vue'
import TextStatisticInput from './TextStatisticInput.vue'

export type Props = {
  dirty?: boolean
  dataType?: SportStats['data_type']
  formatPercent?: boolean
  disabled?: boolean
  size?: 'sm' | 'md'
  decimalPlaces?: number
}

const props = withDefaults(defineProps<Props>(), { size: 'md' })

const stat = defineModel<Stat>({ required: true })

const resolvedDataType = computed(() => props.dataType ?? 'integer')
</script>

<template>
  <DecimalStatisticInput
    v-if="resolvedDataType === 'decimal'"
    v-model="stat"
    :dirty
    :disabled
    :size
    :decimalPlaces
  />
  <BinaryStatisticInput
    v-else-if="resolvedDataType === 'binary'"
    v-model="stat"
    :disabled
  />
  <TextStatisticInput
    v-else-if="resolvedDataType === 'text'"
    v-model="stat"
    :dirty
    :disabled
    :size
  />
  <IntegerStatisticInput
    v-else
    v-model="stat"
    :dirty
    :disabled
    :size
    :formatPercent
  />
</template>
